import AddAttendance from "./addAttendance";
import DownloadReport from "../DownloadReport";

function ManualAttendance() {
  return (
    <>
      <h1>Welcome to Manual Attendance</h1>
      <AddAttendance />
      <DownloadReport />
    </>
  );
}

export default ManualAttendance